import { put, select } from 'redux-saga/effects';
import {
  enqueueErrorSnackbar,
  enqueueSuccessSnackbar,
} from '../notifications/actionWrapper';

import etrApi from '../utils/etrApi';
import { translate } from '../../utils/translation';
import { selectSelectedLanguage } from '../userData/selectors';
import { sendUserAction } from '../../utils/googleAnalytics';
import { returnSnackbarMessage } from '../utils/utils';
export function fetchAdminUsersSagaFactory(actions) {
  return function* () {
    const lang = yield select(selectSelectedLanguage);
    try {
      const { data } = yield etrApi.get('ppm/users');
      if (data) {
        yield put(actions.fetchUsersSuccess(data));
      }
    } catch (e) {
      yield put(actions.fetchUsersError(e));
      yield put(
        enqueueErrorSnackbar(
          returnSnackbarMessage(
            e,
            translate('snackbarMessages.couldNotFetchUsers', lang),
          ),
        ),
      );
    }
  };
}

export function updateUserSagaFactory(actions) {
  return function* ({ payload }) {
    const lang = yield select(selectSelectedLanguage);
    try {
      sendUserAction('Update User');
      const { data } = yield etrApi.put('ppm/user', payload);
      if (data) {
        yield put(actions.updateUserSuccess(data));
        yield put(
          enqueueSuccessSnackbar(
            translate('snackbarMessages.updatedUserSuccessfully', lang),
          ),
        );
      }
    } catch (e) {
      yield put(actions.updateUserError(e));
      yield put(
        enqueueErrorSnackbar(
          translate('snackbarMessages.couldNotUpdateUser', lang),
        ),
      );
    }
  };
}

export function deleteUserSagaFactory(actions) {
  return function* ({ payload }) {
    const lang = yield select(selectSelectedLanguage);
    try {
      sendUserAction('Delete User');
      const { status } = yield etrApi.delete(`ppm/user/${payload.id}`);
      if (status === 200) {
        yield put(actions.deleteUserSuccess(payload));
        yield put(
          enqueueSuccessSnackbar(
            translate('snackbarMessages.deletedUserSuccessfully', lang),
          ),
        );
      }
    } catch (e) {
      yield put(actions.deleteUserError(e));
      yield put(
        enqueueErrorSnackbar(
          returnSnackbarMessage(
            e,
            translate('snackbarMessages.couldNotDeleteUser', lang),
          ),
        ),
      );
    }
  };
}
